export default "__VITE_ASSET__C6fpPud4__"